import { MOD_ENTER, TaskActionBar } from '@/features/contribution-kit';
import type { TranscriptionPhraseCopy } from './transcription-phrase-copy';

type TranscriptionPhraseActionBarProps = {
  t: Record<string, unknown>;
  copy: TranscriptionPhraseCopy;
  canGoPrevious: boolean;
  hasAudio: boolean;
  canSend: boolean;
  isLoading: boolean;
  isSubmitting: boolean;
  onPrevious: () => void;
  onSkip: () => void;
  onSend: () => void;
  onTogglePlay: () => void;
};

/**
 * Bottom bar of "Traduire": previous, skip, send. The handlers keep their
 * own checks and toasts. Keys (outside the text field): Enter sends, left
 * arrow goes back, Space plays the phrase recording when there is one.
 */
export function TranscriptionPhraseActionBar({
  t,
  copy,
  canGoPrevious,
  hasAudio,
  canSend,
  isLoading,
  isSubmitting,
  onPrevious,
  onSkip,
  onSend,
  onTogglePlay,
}: TranscriptionPhraseActionBarProps) {
  return (
    <TaskActionBar
      actions={[
        { key: 'previous', label: String(t.previous ?? ''), icon: 'arrowLeft', onClick: onPrevious, disabled: !canGoPrevious, shortcut: 'ArrowLeft' },
        { key: 'skip', label: copy.skip, icon: 'chevronRight', onClick: onSkip, disabled: isLoading || isSubmitting, testId: 'transcription-phrase-skip' },
        {
          key: 'send',
          label: copy.send,
          icon: 'send',
          tone: 'primary',
          onClick: onSend,
          disabled: isLoading || !canSend,
          loading: isSubmitting,
          // Sends from the text field (Ctrl/Cmd+Enter), plain Enter elsewhere.
          shortcut: MOD_ENTER,
          testId: 'transcription-phrase-send',
        },
      ]}
      extraShortcuts={hasAudio ? [{ key: ' ', run: onTogglePlay }] : []}
      hints={hasAudio ? [{ key: ' ', label: copy.playHint }] : []}
    />
  );
}
